import Store from '@store';
import { Scrollable } from 'src/utils/scrollable';
import { WorkspaceView } from 'src/views/menus/assets';

import EditorFacade from '../../../../facade/editor/editor';
import RestrictDecorate from '../../../../facade/restrictions/decorate';
import CompanyFactory from '../../../../factory/company';
import FontsFactory from '../../../../factory/fonts';
import LibraryFactory from '../../../../factory/library';
import UserInfoFactory from '../../../../factory/user-info';
import humps from '../../../../utils/humps';
import EmbededImportView from '../../embeded-import/view';

import addTemplate from './add-template.hbs';

const libraryFactory = LibraryFactory.instance;
const companyFactory = CompanyFactory.instance;

module.exports = RestrictDecorate(require('./restrict/view'), Backbone.View.extend({
  commonTemplate: require('./common-component.hbs'),
  assetbankCompanies: require('./assetbank-companies.json'),

  hiddenProviders: [
    'photodexia',
    'pixabay',
    'unsplash'
  ],

  events: {
    'click .header-links > .header-scroll > div': 'selectTabEvent',
    'click .header-links > .header-scroll > div[data-key]': 'toggleTabViewEvent',

    'click .search-container input:checkbox': 'checkboxClickEvent',
    'keyup .search-container input': 'searchKeyupEvent',
    'click .search-container input': 'searchClickEvent',
    'click .search-container .search-options-container': 'searchClickEvent',
    'click .search-container .filter-button': 'searchClickEvent',
    'click .search-container .search-button': 'searchTriggerEvent',
    'click .search-container button.upgrade': 'upgradeEvent',
    'click .search-container [data-id=apply-filter-button]': 'applyFilterEvent',

    'click .search-container .search-options > div': 'selectSearchOptionEvent'
  },

  checkboxClickEvent: function (event) {
    const $target = $(event.currentTarget);
    const $assetbank = $('#filter-option-assetbank');

    if ($assetbank.length) {
      $target.is($assetbank) && $target.parents('ul').find('input:checkbox').prop('checked', false);
      $assetbank.prop('checked', $target.is($assetbank));
    }

    $target.parents('ul').find('input:checkbox:checked').length || event.preventDefault();
  },

  selectSearchOptionEvent: function (event) {
    this.invokeChildSearch('selectSearchOptionEvent', event);
    this.setSelectedTabSearchOptionLabel();
  },

  searchClickEvent: function (event) {
    $(event.currentTarget).is('[type=checkbox]') || this.invokeChildSearch('searchClickEvent', event);
  },

  searchOptionsEvent: function (event) {
    this.invokeChildSearch('searchOptionsEvent', event);
  },

  searchKeyupEvent: function (event) {
    event.key === 'Enter' && this.applyFilterEvent(event);
  },

  applyFilterEvent: function () {
    this.$el.find('.search-title').is('.hidden') && this.$el.find('input[type=text]').toggleClass('searching');
    this.$el.find('.filter-container').hide();
    this.invokeChildSearch('search', this.$el.find('input[type=text]'));
  },

  searchTriggerEvent: function (event) {
    const $searchInput = $(event.currentTarget).siblings('input');
    $searchInput.val() && this.invokeChildSearch('search', $searchInput);
  },

  invokeChildSearch: function (searchMethod, data) {
    this.selectedTab && this.selectedTab.searchable &&
    this.selectedTab.view &&
    this.selectedTab.view[searchMethod] &&
    this.selectedTab.view[searchMethod](data);
  },

  toggleTabViewEvent: function (event) {
    const key = $(event.currentTarget).data('key');

    if (this.tabs[key].view) {
      this.tabs[key].view.$el.show();
      key === 'add' && this.embededImportView && this.embededImportView.refresh();
    } else {
      const tabViewInitializer = 'init' + humps.pascalize(key) + 'View';
      this[tabViewInitializer](event);
    }

    this.scrollable.scrollToElement(event.currentTarget);
  },

  initLibraryView: function () {
    // Available props: this.canUseLibrary, this.type, this.domain, this.parentCompany, this.workspace
    const typeMap = {
      image: 'tabImages',
      icon: 'tabIcons',
      logo: 'tabLogos',
      text: 'tabText',
      video: 'tabVideo'
    };
    const selector = `#${typeMap[this.type]} .tab-content.${this.type} .library`;

    const app = new WorkspaceView({
      appId: `assets-${this.type}`,
      type: this.type,
      targetNodeSelector: selector,
      collection: 'assets'
    });

    app.mountApp();
  },

  initUserLibraryView: function () {
    const typeMap = {
      image: 'tabImages',
      icon: 'tabIcons',
      logo: 'tabLogos',
      text: 'tabText',
      video: 'tabVideo'
    };
    const selector = `#${typeMap[this.type]} .tab-content.${this.type} .user_library`;

    const app = new WorkspaceView({
      appId: `library-${this.type}`,
      type: this.type,
      targetNodeSelector: selector,
      collection: 'library'
    });

    app.mountApp();
  },

  selectTabEvent: function (event) {
    const $tabButton = $(event.currentTarget);
    const $containers = this.$el.find('>.tab-content>div:not(.header-links)');

    this.selectedTab = _.clone(this.tabs[$tabButton.data('key')]);

    $tabButton.siblings().removeClass('active');
    this.$el.find('.library').hide();
    $containers.hide();
    this.updateSearchContainer();

    $containers.filter('.' + this.selectedTab.key).show();
    $containers.filter(`#react-${this.selectedTab.key}-${this.type}`).show();

    this.refreshView(this.selectedTab.key);
    $tabButton.addClass('active');
    EditorFacade.trigger('switch_tab', {
      panel: INKIVE.Helpers.getActiveTab(),
      tab: this.selectedTab.key
    });
  },

  show: function () {
    this.companyData
      ? _show.call(this)
      : companyFactory.getCompany().then((companyData) => {
        this.companyData = companyData;
        _show.call(this);
      });

    function _show () {
      if (this.isAlreadyThere) {
        this.isAlreadyThere() ? this.refresh() : this.render();
      }
    }
  },

  initialize: function () {
    this.isCompanyProject = INKIVE.Helpers.projectIsLinkedToRestrictions();
    this.tabs = JSON.parse(JSON.stringify(require('./tabs.json')));

    if (!this.isCompanyProject) {
      this.tabs.library.type = [];
    }

    Promise.all([
      UserInfoFactory.get(),
      UserInfoFactory.getMembership()
    ]).then(([userInfo, membershipInfo]) => {
      this.membershipInfo = membershipInfo;
      this.isPro = hasRole('ROLE_PRO');

      this.isBusiness = hasRole('ROLE_BUSINESS');
      this.hasContentPlan = hasRole('ROLE_CONTENT2');

      this.canUseUpload = hasRole('ROLE_PREMIUM');
      this.canUseFilters = this.canUseUpload ||
        INKIVE.Helpers.projectIsLinkedToRestrictions();

      this.canUseLibrary = hasRole('ROLE_LIBRARY') ||
        INKIVE.Helpers.projectIsLinkedToRestrictions();

      if (hasRole('ROLE_COMPANY_MEMBER') && this.isCompanyProject) {
        this.canUseUpload = this.canUseLibrary = true;
      }

      function hasRole (role) {
        return _(userInfo.roles).contains(role);
      }
    });
  },

  render: function () {
    const whiteLabelConfig = INKIVE.C.WHITE_LABEL_CONFIGURATION || {};
    const state = Store.getState();

    this.domain = this.companyData.domain;
    this.workspace = INKIVE.C.WORKSPACE;
    this.isAssetBankCompany = this.assetbankCompanies.includes(this.companyData.domain);
    this.isKW = INKIVE.C.USER.kw_uid !== undefined;
    this.isEnterprise = whiteLabelConfig.subscription_plan === 'enterprise';
    this.parentCompany = this.workspace && whiteLabelConfig.parent_company;

    const hasFilter = _.include(['image', 'icon', 'search'], this.type) && !this.isKW;

    // Gradients UI is only available to design-team (this restriction is to be removed)
    const designTeamID = 22047;
    const isDesignTeamWorkspace = this.companyData && this.companyData.id === designTeamID;
    if (!isDesignTeamWorkspace) {
      this.tabs.gradients.type = [];
    }

    const allowedTabs = _.filter(this.tabs, shouldShowButton.bind(this), this);
    INKIVE.EditorFacade.trigger(`tab-${this.type}.innertabs`, { numTabs: allowedTabs.length });

    if (allowedTabs.length > 0) {
      this.$el.html(this.commonTemplate({
        type: this.type,
        tabs: allowedTabs,
        has_filter: hasFilter
      }));
    }

    this.$headerLinks = this.$el.find('.header-links .header-scroll > div');
    if (this.$headerLinks.length > 0) {
      this.initScrollableHeaderLinks();
    }

    function shouldShowButton (button) {
      const isButtonAllowed = button.type.includes(this.type);

      if (button.key === 'paragraph_styles' && this.type === 'text') {
        return typeof state.metadata?.paragraph_styles !== 'undefined';
      }

      if (button.key === 'library' && this.isCompanyProject && this.membershipInfo) {
        return this.membershipInfo?.permissions?.assets_view && isButtonAllowed;
      }

      return isButtonAllowed;
    }
  },

  refresh: function () {
    if (!this.selectedTab?.key) return;

    this.refreshView(this.selectedTab.key);
    this.embededImportView && this.embededImportView.refresh();
  },

  refreshView: function (key) {
    this.tabs[key].view &&
    this.tabs[key].view.refresh &&
    this.tabs[key].view.refresh();
  },

  initScrollableHeaderLinks: function () {
    this.scrollable?.destroy();

    this.scrollable = new Scrollable({
      scrollableRef: this.$el.find('.header-links .header-scroll')[0],
      leftController: this.$el.find('.header-links .header-links-prev')[0],
      rightController: this.$el.find('.header-links .header-links-next')[0]
    });

    this.scrollable.initialize();
  },

  initAddView: function () {
    const html = addTemplate({
      type: this.type,
      dragdrop_text: INKIVE.TranslateHelper.translate('tool.general.dragdrop.' + this.type),
      isDesygner: !this.isCompanyProject,
      canUseUpload: this.canUseUpload || this.type === 'image'
    });

    this.$el.find('.tab-content > .add').html(html);
    this.embededImportView = new EmbededImportView({ canUse: this.canUseUpload });
    this.embededImportView.loadImportedListContent(
      this.type, this.$el.find('[data-key="' + this.type + '-import"]')
    );
  },

  initStockView: function () {
    const $stock = this.$el.find('.tab-content > .stock');
    this.registerTabView('stock', new this.StockView({
      el: $stock[0],
      isAssetBankCompany: this.isAssetBankCompany,
      isKW: this.isKW,
      initSearch: _.bind(this.initSearchOptions, this)
    }));
  },

  refreshUserLibrary: function (event) {
    const changedAssets = event.originalEvent && event.originalEvent.detail;

    if (_.intersection(changedAssets, this.memberType).length) {
      this.tabs.user_library.view = null;
    }

    if (_.contains(changedAssets, 'brand')) {
      libraryFactory.cache.member = null;
      FontsFactory.initialize().then(function () {
        const tool = INKIVE.Tool.getInstance();

        $('#font-menu-list').remove();
        tool.editor.canvas.clearSelection();
      });
    }
  },

  updateSearchContainer: function () {
    this.selectedTab.searchable &&
    this.displaySearchContainer(this.$el.find('.search-container'));
  },

  displaySearchContainer: function ($searchContainer) {
    const $input = $searchContainer.find('input');
    $input.attr('autocomplete', 'off');

    $searchContainer.show();
    $searchContainer.find('.search-options, .filter-container').hide();

    this.setSelectedTabSearchTitle();
    $input.attr('placeholder', this.selectedTab.searchTitle);
    $input.val('');

    this.selectedTab.view &&
    this.selectedTab.view.getSearchOptions &&
    this.initSearchOptions();
  },

  initSearchOptions: async function () {
    if (!this.selectedTab.view || (this.searchLoaded && !['mns'].includes(this.selectedTab.key))) return;
    const $searchContainer = this.$el.find('.search-container:first').addClass('disabled');

    this.selectedTabView = this.selectedTab.view;
    this.searchLoaded = true;

    const providers = await INKIVE.DesygnerApi.get('business/marketplace/providers');

    companyFactory.getCompanyItems('is_legacy').then((isLegacy) => {
      INKIVE.C.IS_DESYGNER_BUSINESS = (isLegacy === false);
    });

    this.selectedTabView.canUseLibrary = this.canUseLibrary;
    this.selectedTabView.canUseFilters = this.canUseFilters;

    this.types = this._getSearchTypes();
    this.providers = this._getProviders(providers);
    const $searchOptions = this.selectedTabView.getSearchOptions(this.providers, this.types).hide();
    const enabledFilters = [
      ...this._getSelectedProviders(),
      ...this._getSelectedTypes()
    ].map(e => `input#filter-option-${e}`).join();

    $searchContainer.append($searchOptions);
    $searchOptions.is('.filter-container') || this.setSelectedTabSearchOptionLabel();
    $searchContainer.removeClass('disabled');
    $searchOptions.find(enabledFilters).trigger('click');

    this.delegateEvents();

    INKIVE.EditorFacade.trigger('searchOptionsLoaded', { providers });
  },

  _getSelectedTypes: function () {
    const types = ['free'];
    const workspaceAllowsUpselling = INKIVE.C.FEATURE_FLAG?.users?.includes('allows_user_upselling');

    // if (workspaceAllowsUpselling) {
    //   const index = types.indexOf('free');
    //   types.splice(index, 1);
    // }

    if (!this.isPro || !this.isBusiness || workspaceAllowsUpselling) {
      types.push('upsale');
    }

    if (this.isPro || this.hasContentPlan) {
      types.push('plan');
    }

    if (this.isPro && !this.isBusiness) {
      types.push('other');
    }

    return types;
  },

  _getSelectedProviders: function () {
    const providers = ['photodexia'];

    this.canUseFilters && providers.push('unsplash', 'pixabay');

    return providers;
  },

  _getProviders: function (providers) {
    delete providers.sstk;

    if (this.type === 'icon') {
      delete providers.unsplash;
    }

    if (this.isKW) {
      delete providers.google;
      delete providers.pixabay;
    }

    return Object.keys(providers).map((key) => ({
      key,
      label: INKIVE.TranslateHelper.translate('tool.search.providers.' + key),
      hidden: this.hiddenProviders.includes(key)
    }));
  },

  _getSearchTypes: function () {
    const types = ['free', 'plan', 'upsale'];
    const workspaceAllowsUpselling = INKIVE.C.FEATURE_FLAG?.users?.includes('allows_user_upselling');
    const isEnterprise = INKIVE.C.WHITE_LABEL_CONFIGURATION.subscription_plan === 'enterprise';

    if (!this.isPro) {
      const index = types.indexOf('plan');
      types.splice(index, 1);
    }

    if (!workspaceAllowsUpselling || this.hasContentPlan || this.isBusiness && !isEnterprise) {
      const index = types.indexOf('upsale');
      types.splice(index, 1);
    }

    if (this.isPro && !this.isBusiness) {
      types.push('other');
    }

    return types.map((key) => ({
      key, label: INKIVE.TranslateHelper.translate('tool.search.types.' + key)
    }));
  },

  setSelectedTabSearchOptionLabel: function () {
    const $searchOptions = this.selectedTab.view.getSearchOptions(this.providers, this.types);
    let $selectedOption = $searchOptions.find('.selected');
    const $optsLabel = this.$el.find('.search-options-container');

    if (!$selectedOption.length) {
      $selectedOption = $searchOptions.find(':first');
      $('<i class="desygner-icon-check">').prependTo($selectedOption.addClass('selected'));
    }

    const label = $selectedOption.find('span').html();

    $optsLabel.find('>span').html(label).attr('data-original-title', label);
    $searchOptions.find('>div').length > 1 && $optsLabel.css('display', 'grid').parent().addClass('add-search-options');

    INKIVE.Helpers.initTooltips($optsLabel);
  },

  setSelectedTabSearchTitle: function () {
    const key = this.selectedTab.key;

    this.selectedTab.searchTitle = INKIVE.TranslateHelper.translate('tool.search.' + key,
      {
        type: INKIVE.TranslateHelper.translate('tool.library.' + this.type),
        origin: INKIVE.TranslateHelper.translate('tool.general.' +
          (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESIGN ? 'my_library' : 'company'))
      });
  },

  registerTabView: function (key, view) {
    this.tabs[key].view = view;

    if (this.selectedTab.key === key) {
      this.selectedTab.view = view;
      this.tabs[key].view.getSearchOptions && this.initSearchOptions();
    }
  },

  upgradeEvent: function () {
    INKIVE.Helpers.displaySubscriptionModal();
  },

  checkEmptyLibrary: function ($fallbackTab) {
    let contents = 0;
    let count = 0;
    const $headerLinks = this.$headerLinks.addClass('loading');
    let $libraryTab = this.$headerLinks.filter('[data-key=user_library]');

    if (!$libraryTab.length) {
      $libraryTab = this.$headerLinks.filter('[data-key=library]');
    }

    function isLibraryEmpty (data) {
      contents += data.content.length;
      count++;

      if (count > 1) {
        contents || $fallbackTab[0].click();
        EditorFacade.off('library.root', isLibraryEmpty);
        $headerLinks.removeClass('loading');
      }
    }

    EditorFacade.on('library.root', isLibraryEmpty);
    $fallbackTab[0].click();
  }
}));
